export const defaultAttributes = {
    RELATED_ARTICLES_TITLE: 'Recommended For You'
}
export const testAttributes = {
    RELATED_ARTICLES_TITLE: 'wp-page-related-grid-title'
}
